import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CourierLegendItem } from '../delivery-plan-viewer.models';
import { LEGEND_SELECTED_BACKGROUND_ALPHA } from '../delivery-plan-viewer.constants';

@Component({
    selector: 'app-delivery-plan-viewer-courier-legend',
    templateUrl: './delivery-plan-viewer-courier-legend.component.html',
    styleUrls: ['./delivery-plan-viewer-courier-legend.component.scss'],
})
export class DeliveryPlanViewerCourierLegendComponent {
    @Input() public items: CourierLegendItem[] = [];
    @Input() public filteredCourierId: string | null = null;

    @Output() public filterChanged = new EventEmitter<string | null>();

    public onItemClicked(item: CourierLegendItem): void
    {
        this.filterChanged.emit(this.filteredCourierId === item.courierId ? null : item.courierId);
    }

    public selectedBackground(color: string): string
    {
        return `${color}${LEGEND_SELECTED_BACKGROUND_ALPHA}`;
    }

    public trackByCourierId(_index: number, item: CourierLegendItem): string
    {
        return item.courierId;
    }

}